// 常用错误类型
export default {
    "401" : "http_error_514",
    "405" : "http_error_514",
    "518" : "http_error_514",
    "400" : "invalid",
    "500" : "http_error_500",
    "406" : "error_code_406",
    "513" : "http_error_513",
}